  <div class="d-flex flex-column align-items-center text-color-neutral">
    <div class="my-3 footer-secondaire-title">
      {{appName}}
    </div>
    <div class="my-1 text-center version-color">
      <div>
        Les personnes listées dans ce registre sont issues des accueils sécurité réalisés dans Portail Chantier et des pointages de l'application PCO.
      </div>
    </div>
    <div class="my-1 text-center version-color">
      ©{{currentYear}} Léon Grosse
    </div>
    <div class="my-1 text-center version-color">
      Version {{version}} / {{backendVersion()}}
    </div>
  </div>
